<mat-accordion>
  <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" hideToggle="true"
    [expanded]="panelOpenState" id="connection">
    <mat-expansion-panel-header class="connection-header">
      <div class="connection-header-row">
        <mat-panel-title class="connection-title">
          Connection Details
        </mat-panel-title>
        <span class="span-slide-toggle"><mat-slide-toggle [checked]="panelOpenState"></mat-slide-toggle></span>
      </div>
    </mat-expansion-panel-header>


    <form [formGroup]="form">
      <mat-tab-group class="global-tabs" mat-align-tabs="start" animationDuration="0ms" [mat-stretch-tabs]="true">
        <mat-tab label="Incoming">
          <mat-card-content>
            <br>
            <div class="row form-row">
              <div class="col-md-2">
                <label class="lbl_fld">Mckesson Client ID</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="OktaMckClientId"
                    placeholder="Mckesson Client ID">
                  <mat-error *ngIf="form && form.get('OktaMckClientId')?.invalid && (form.get('OktaMckClientId')?.dirty || form.get('OktaMckClientId')?.touched)">
                    {{ errorMessageForOktaMckClientId }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-tab>
        <mat-tab label="Outgoing">
          <mat-card-content>



            <div class="row form-row">
              <div class="col-md-2">
                <label class="lbl_fld" style="padding-bottom: 0%;">Auth Type</label><span class="asterick">*</span>
              </div>
              <div class="col-md-6">



<div class="button-toggle">
  <button type="button"
          [class.active]="useOkta === false"
          (click)="onUseOkta({ value: 'BASIC' })">
    BASIC
  </button>
  <button type="button"
          [class.active]="useOkta === true"
          (click)="onUseOkta({ value: 'OKTA' })">
    OKTA
  </button>
</div>
<input type="hidden" formControlName="AuthType" [value]="useOkta === true ? 'OKTA' : useOkta === false ? 'BASIC' : ''">



              </div>
            </div>
                          <div *ngIf="useOkta !== null">

            <div class="row form-row">
              <div class="col-md-2" *ngIf="!useOkta">
                <label class="lbl_fld">UserName</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4" *ngIf="!useOkta">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="BasicUserName"
                    placeholder="UserName">
                  <mat-error *ngIf="form && form.get('BasicUserName')?.invalid && (form.get('BasicUserName')?.dirty || form.get('BasicUserName')?.touched)">
                    {{ errorMessageForBasicUserName }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-2" *ngIf="useOkta">
                <label class="lbl_fld">Client Id</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4" *ngIf="useOkta">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="OktaClientId"
                    placeholder="Client Id">
                  <mat-error *ngIf="form && form.get('OktaClientId')?.invalid && (form.get('OktaClientId')?.dirty || form.get('OktaClientId')?.touched)">
                    {{ errorMessageForOktaClientId }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-2" *ngIf="!useOkta">
                <label class="lbl_fld">Endpoint URL</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4" *ngIf="!useOkta">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="BasicEndpointURL"
                    placeholder="Endpoint URL">
                  <mat-error *ngIf="form && form.get('BasicEndpointURL')?.invalid && (form.get('BasicEndpointURL')?.dirty || form.get('BasicEndpointURL')?.touched)">
                    {{ errorMessageForBasicEndpointURL }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-2" *ngIf="useOkta">
                <label class="lbl_fld">Endpoint URL</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4" *ngIf="useOkta">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="OktaEndpointURL"
                    placeholder="Endpoint URL">
                  <mat-error *ngIf="form && form.get('OktaEndpointURL')?.invalid && (form.get('OktaEndpointURL')?.dirty || form.get('OktaEndpointURL')?.touched)">
                    {{ errorMessageForOktaEndpointURL }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row form-row" *ngIf="!useOkta">
              <div class="col-md-2">
                <label class="lbl_fld">Password</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="password"
                    formControlName="BasicPassword"
                    [placeholder]="inputModel.HiddenPassword?'**********':'Password'"
                    [matTooltip]="inputModel.HiddenPassword?'Password is hidden':''">
                  <mat-error *ngIf="form && form.get('BasicPassword')?.invalid && (form.get('BasicPassword')?.dirty || form.get('BasicPassword')?.touched)">
                    {{ errorMessageForBasicPassword }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row form-row" *ngIf="useOkta">
              <div class="col-md-2">
                <label class="lbl_fld">Client Secret</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="password"
                    formControlName="OktaClientSecret"
                    [placeholder]="inputModel.HiddenClientSecret?'**********':'Client Secret'"
                    [matTooltip]="inputModel.HiddenClientSecret?'Client Secret is hidden':''">
                  <mat-error *ngIf="form && form.get('OktaClientSecret')?.invalid && (form.get('OktaClientSecret')?.dirty || form.get('OktaClientSecret')?.touched)">
                    {{ errorMessageForOktaClientSecret }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-2">
                <label class="lbl_fld">Auth URL</label><span class="asterick">*</span>
              </div>
              <div class="col-md-4">
                <mat-form-field class="ffs" appearance="outline" style="width:100%;">
                  <input matInput
                    type="text"
                    formControlName="OktaAuthURL"
                    placeholder="Auth URL">
                  <mat-error *ngIf="form && form.get('OktaAuthURL')?.invalid && (form.get('OktaAuthURL')?.dirty || form.get('OktaAuthURL')?.touched)">
                    {{ errorMessageForOktaAuthURL }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-2" style="text-align: left;">
                <button type="button" mat-raised-button color="primary" class="btn-test-connection" style="margin-bottom: 2%;" (click)="testConnection()">Test Connection</button>
              </div>
              <div class="col-md-10">
                <div *ngIf="isLoading">Loading...</div>
                <div *ngIf="!isLoading && connectionMessage" [ngClass]="{'success': isConnectionSuccessful, 'failure': !isConnectionSuccessful}">
                  {{ connectionMessage }}
                </div>
              </div>
            </div>
            </div>
          </mat-card-content>
        </mat-tab>
      </mat-tab-group>
    </form>
  </mat-expansion-panel>
</mat-accordion>